import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../rootStore";

export const selectCurrentExam = ({ exam }: RootState) => exam.currentExam;

export const selectLoading = ({ exam }: RootState) => exam.loading;

export const selectIsRemoveModalVisible = ({ exam }: RootState) =>
  exam.isRemoveModalVisible;
export const selectIsDetailsModalVisible = ({ exam }: RootState) =>
  exam.isDetailsModalVisible;

export const selectRegionInfo = createSelector(
  selectCurrentExam,
  ({ movement, joint }) => ({
    movement: movement?.name,
    side: joint?.side,
    jointName: joint?.name,
  })
);

export const selectScoreInfo = createSelector(
  selectCurrentExam,
  ({ painScaleValue, outcomeScore }) => ({
    painScale: painScaleValue,
    survey: outcomeScore,
  })
);

export const selectExamFrames = ({ exam }: RootState) => exam.examFrames;
